<div class="error-container">
  <aur-notice severity="error" title="{{ titleKey | translate }}">
    {{ messageKey | translate }}
  </aur-notice>
</div>
